<template>
  <div class="agenda-header">
    <div class="flex header-left">
      <div class="heading-large">Agenda</div>
      <div class="btn btn-secondary ml-3" @click="today()">Today</div>
      <div class="flex ml-3 align-items-center" v-if="selected_tasks.length > 0">
        <div @click="deselectAllTasks()" class="btn btn-silent" style="font-size: 18px; padding: .35rem 0.7rem;">X</div>
        <div class="text-large ml-3">{{ selected_tasks.length }} assignments selected:</div>
        <div class="flex">
          <div class="btn btn-secondary ml-3" @click="duplicateToNextDay()">Duplicate to next day</div>
          <div class="btn btn-secondary ml-3" @click="duplicateToRestOfWeek()">Duplicate to whole week</div>
          <div class="btn btn-secondary ml-3" @click="unassign()">Unassign</div>
        </div>
      </div>
    </div>
    <div class="header-right">
<!--      <div class="btn btn-secondary">Action tray</div>-->
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.$root.$on('TaskSelector::updated', ({selected_tasks}) => {
      this.selected_tasks = selected_tasks
    })
  },
  data() {
    return {
      selected_tasks: [],
    }
  },
  methods: {
    today() {
      this.$root.$emit('Header2::today')
    },
    deselectAllTasks() {
      this.$root.$emit('TaskSelector::deselect-all')
    },
    unassign() {
      let tasks = _.map(this.selected_tasks, t => t.id)
      this.axios.post('/n/tasks/unassign', {tasks}).then(response => {
        _.each(response.data.data, task => {
          this.$root.$emit('Tasks::deleted', {task})
          this.deselectAllTasks()
        })
      })
    },
    duplicateToNextDay() {
      let tasks = _.map(this.selected_tasks, t => t.id)
      this.axios.post('/n/tasks/duplicate-to-next-day', {tasks}).then(response => {
        _.each(response.data.data, task => {
          this.$root.$emit('Tasks::created', {task})
          this.deselectAllTasks()
        })
      })
    },
    duplicateToRestOfWeek() {
      let tasks = _.map(this.selected_tasks, t => t.id)
      this.axios.post('/n/tasks/duplicate-to-rest-of-week', {tasks}).then(response => {
        console.log(response.data.data)
        _.each(response.data.data, task => {
          this.$root.$emit('Tasks::created', {task})
          this.deselectAllTasks()
        })
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/agenda-v2/header1.vue